import { createAction } from '@reduxjs/toolkit';
import { graphql, readInlineData } from 'relay-runtime';
import {
    checkoutRelayAction_viewer$key,
    checkoutRelayAction_viewer$data,
} from './__generated__/checkoutRelayAction_viewer.graphql';
import {
    checkoutRelayAction_item$key,
    checkoutRelayAction_item$data,
} from './__generated__/checkoutRelayAction_item.graphql';
import {
    checkoutRelayAction_buyer$key,
    checkoutRelayAction_buyer$data,
} from './__generated__/checkoutRelayAction_buyer.graphql';
import {
    checkoutRelayAction_emailUser$key,
    checkoutRelayAction_emailUser$data,
} from './__generated__/checkoutRelayAction_emailUser.graphql';
import {
    checkoutRelayAction_preCheckoutTransaction$key,
    checkoutRelayAction_preCheckoutTransaction$data,
} from './__generated__/checkoutRelayAction_preCheckoutTransaction.graphql';

export const buyerItemViewerFetchedAction = createAction<
    (payload: {
        viewer: checkoutRelayAction_viewer$key;
        item: checkoutRelayAction_item$key | null;
        buyer: checkoutRelayAction_buyer$key | null;
        emailUser: checkoutRelayAction_emailUser$key | null;
        preCheckoutTransaction: checkoutRelayAction_preCheckoutTransaction$key | null;
    }) => {
        payload: {
            viewer: checkoutRelayAction_viewer$data;
            item: checkoutRelayAction_item$data | null;
            buyer: checkoutRelayAction_buyer$data | null;
            emailUser: checkoutRelayAction_emailUser$data | null;
            preCheckoutTransaction: checkoutRelayAction_preCheckoutTransaction$data | null;
        };
    }
>(
    'CHECKOUT_BUYER_ITEM_VIEWER_UPDATE',
    ({
        viewer: viewerRef,
        item: itemRef,
        buyer: buyerRef,
        emailUser: emailUserRef,
        preCheckoutTransaction: preCheckoutTransactionRef,
    }) => {
        const viewer = readInlineData(
            graphql`
                fragment checkoutRelayAction_viewer on Viewer @inline {
                    ...checkoutTransactionReducer_viewer
                    ...checkoutShippingReducer_viewer
                }
            `,
            viewerRef
        );

        const item = readInlineData(
            graphql`
                fragment checkoutRelayAction_item on Item @inline {
                    ...checkoutTransactionReducer_item
                }
            `,
            itemRef
        );

        const buyer = readInlineData(
            graphql`
                fragment checkoutRelayAction_buyer on User @inline {
                    ...checkoutTransactionReducer_buyer
                    ...checkoutShippingReducer_buyer
                    ...checkoutPaymentReducer_buyer
                }
            `,
            buyerRef
        );

        const emailUser = readInlineData(
            graphql`
                fragment checkoutRelayAction_emailUser on User @inline {
                    ...checkoutShippingReducer_emailUser
                }
            `,
            emailUserRef
        );

        const preCheckoutTransaction = readInlineData(
            graphql`
                fragment checkoutRelayAction_preCheckoutTransaction on Transaction @inline {
                    ...checkoutTransactionReducer_preCheckoutTransaction
                    ...checkoutShippingReducer_preCheckoutTransaction
                    ...checkoutPaymentReducer_preCheckoutTransaction
                }
            `,
            preCheckoutTransactionRef
        );

        return {
            payload: {
                type: 'CHECKOUT_BUYER_ITEM_VIEWER_UPDATE',
                viewer,
                item,
                buyer,
                preCheckoutTransaction,
                emailUser,
            },
        };
    }
);

// type this file after inline transaction fragments are created in checkoutPaymentReducer and checkoutTransactionReducer
export const transactionRecomputedAction = createAction<$TSFixMe>('TRANSACTION_RECOMPUTED');
